var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcScope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#003EA8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30C18.6167 30 17.3167 29.7375 16.1 29.2125C14.8833 28.6875 13.825 27.975 12.925 27.075C12.025 26.175 11.3125 25.1167 10.7875 23.9C10.2625 22.6833 10 21.3833 10 20C10 18.6167 10.2625 17.3167 10.7875 16.1C11.3125 14.8833 12.025 13.825 12.925 12.925C13.825 12.025 14.8833 11.3125 16.1 10.7875C17.3167 10.2625 18.6167 10 20 10C21.3833 10 22.6833 10.2625 23.9 10.7875C25.1167 11.3125 26.175 12.025 27.075 12.925C27.975 13.825 28.6875 14.8833 29.2125 16.1C29.7375 17.3167 30 18.6167 30 20C30 21.3833 29.7375 22.6833 29.2125 23.9C28.6875 25.1167 27.975 26.175 27.075 27.075C26.175 27.975 25.1167 28.6875 23.9 29.2125C22.6833 29.7375 21.3833 30 20 30ZM19 27.95V26C18.45 26 17.9792 25.8042 17.5875 25.4125C17.1958 25.0208 17 24.55 17 24V23L12.2 18.2C12.15 18.5 12.1042 18.8 12.0625 19.1C12.0208 19.4 12 19.7 12 20C12 22.0167 12.6625 23.7833 13.9875 25.3C15.3125 26.8167 16.9833 27.7 19 27.95ZM25.9 25.4C26.5833 24.65 27.1042 23.8125 27.4625 22.8875C27.8208 21.9625 28 21 28 20C28 18.3667 27.5458 16.875 26.6375 15.525C25.7292 14.175 24.5167 13.2 23 12.6V13C23 13.55 22.8042 14.0208 22.4125 14.4125C22.0208 14.8042 21.55 15 21 15H19V17C19 17.2833 18.9042 17.5208 18.7125 17.7125C18.5208 17.9042 18.2833 18 18 18H16V20H22C22.2833 20 22.5208 20.0958 22.7125 20.2875C22.9042 20.4792 23 20.7167 23 21V24H24C24.4333 24 24.825 24.1292 25.175 24.3875C25.525 24.6458 25.7667 24.9833 25.9 25.4Z",
    fill: "#3F51B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScope);
export default __webpack_public_path__ + "static/media/ic-scope.9b0038421fc0ae64f14576715fe22e31.svg";
export { ForwardRef as ReactComponent };